var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',{class:{
        'required-field': _vm.field.isRequired,
    },attrs:{"label":_vm.field.label,"label-for":`id_${_vm.field._id}`}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({
            required: _vm.field.isRequired,
            email: !!_vm.field.isEmail,
            numeric:
                this.$store.state.registration.form.identityInfo.type ==
                    'passport'
                    ? false
                    : !!_vm.field.isNumeric,
            alpha_num:
                this.$store.state.registration.form.identityInfo.type ==
                    'passport'
                    ? !!_vm.field.isAlphaNum
                    : _vm.field.isAlphaNum
                        ? !!_vm.field.isAlphaNum
                        : !!_vm.field.isAlphaNum,
            alpha_spaces: !!_vm.field.isAlpha,
            min:
                this.$store.state.registration.form.identityInfo.type ==
                    'passport'
                    ? 1
                    : _vm.field.minLength
                        ? _vm.field.minLength
                        : 1,
            max:
                _vm.field.maxLength != null
                    ? _vm.field.maxLength
                    : this.$store.state.registration.form.identityInfo.type == 'passport'
                        ? 100
                        : this.$store.state.registration.form.identityInfo.type == 'id'
                            ? 50
                            : 100
        }),expression:"{\n            required: field.isRequired,\n            email: !!field.isEmail,\n            numeric:\n                this.$store.state.registration.form.identityInfo.type ==\n                    'passport'\n                    ? false\n                    : !!field.isNumeric,\n            alpha_num:\n                this.$store.state.registration.form.identityInfo.type ==\n                    'passport'\n                    ? !!field.isAlphaNum\n                    : field.isAlphaNum\n                        ? !!field.isAlphaNum\n                        : !!field.isAlphaNum,\n            alpha_spaces: !!field.isAlpha,\n            min:\n                this.$store.state.registration.form.identityInfo.type ==\n                    'passport'\n                    ? 1\n                    : field.minLength\n                        ? field.minLength\n                        : 1,\n            max:\n                field.maxLength != null\n                    ? field.maxLength\n                    : this.$store.state.registration.form.identityInfo.type == 'passport'\n                        ? 100\n                        : this.$store.state.registration.form.identityInfo.type == 'id'\n                            ? 50\n                            : 100\n        }"}],class:{
                'is-invalid': _vm.errors.has(_vm.field.label),
            },attrs:{"type":"text","autocomplete":"no","placeholder":_vm.field.placeholder,"disabled":_vm.loading,"data-vv-name":_vm.field.label},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }